import React, { Component } from 'react';
import { Tabs } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import '../style/home.less';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class MainContent extends Component {
    state = {
        panes: [],
        activeKey: '',
    }

    componentDidMount() {
        const { startDate, endDate } = this.props;
        this.changePanes(startDate, endDate);
    }

    componentWillReceiveProps(nextProps) {
        const { startDate, endDate } = this.props;
        if (startDate !== nextProps.startDate || endDate !== nextProps.endDate) {
            this.changePanes(nextProps.startDate, nextProps.endDate);
        }
    }

    changePanes = (startDate, endDate) => {
        const panes = [];
        let newValue = moment(startDate);
        const endValue = moment(endDate);
        const activeKey = newValue.format(monthFormat);
        while (newValue.valueOf() <= endValue.valueOf()) {
            panes.push({
                title: newValue.format(monthFormat),
                content: null,
            });
            newValue = newValue.add(1, 'M');
        }
        this.setState({
            panes,
            activeKey,
        }, () => {
            this.queryMember();
        })
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.queryMember()
        })
    }

    queryMember = () => {
        const { userId } = this.props;
        const { activeKey } = this.state;
        this.setState({ memberLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryPerformanceSupervisorTeam,
            data: {
                userId,
                date: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                this.setState({
                    memberData: data,
                    memberLoading: false,
                }, () => {
                    const { panes } = this.state;
                    panes.forEach(item => {
                        if (item.title == activeKey) {
                            item.content = this.getMemberTable();
                        } else {
                            item.content = null;
                        }
                    });
                    this.setState({ panes });
                })
            },
            errorResult: () => {
                this.setState({ memberLoading: false });
            }
        };
        $.sendRequest(options);
    }

    getMainTable = () => {
        const { loading, restDatas: { mainData = [] } } = this.props;
        const getColumns = () => ([
            {
                title: '考核项',
                dataIndex: 'itemName',
                key: 'itemName',
                render: (text, record) => {
                    const { fullScore } = record;
                    if (text == '团队规模') {
                        return <span>{text}（上限：{fullScore || 0}分）</span>
                    } else if (text.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }, {
                title: '得分',
                dataIndex: 'score',
                key: 'score',
                width: 370,
                render: (text, record) => {
                    if (record.itemName.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }
        ]);

        const getDataSource = () => {
            const dataSource = mainData.map(item => {
                return {
                    ...item,
                };
            })
            return dataSource;
        };

        return (
            <TableC
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                rowKey='performanceItemId'
                className="mainPerformance"
            />
        )
    }

    getMemberRender = (colSpan, type) => {
        return (text, record) => {
            if (type == 'date') {
                text = text ? text.slice(0, 10) : '-';
            } else if (type == 'fill') {
                text = text ? text : 0;
            }
            const obj = {
                children: text,
                props: {},
            };
            const { employeeCode } = record;
            if (employeeCode == '合计') {
                obj.props.colSpan = colSpan;
                obj.children = <strong>{text}</strong>
            }
            return obj;
        }
    }

    // 团队人员明细
    getMemberTable = () => {
        const { memberData = [], memberLoading = false } = this.state;
        const getColumns = () => ([
            {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 80,
                fixed: 'left',
                render: this.getMemberRender(7),
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
                fixed: 'left',
                render: this.getMemberRender(0),
            }, {
                title: '职位/级别',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 130,
                render: this.getMemberRender(0),
            }, {
                title: '主管领导',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 80,
                render: this.getMemberRender(0),
            }, {
                title: '部门',
                dataIndex: 'enterpriseDepartmentName',
                key: 'enterpriseDepartmentName',
                width: 80,
                render: this.getMemberRender(0),
            }, {
                title: '状态',
                dataIndex: 'workingStatus',
                key: 'workingStatus',
                width: 80,
                render: this.getMemberRender(0),
            }, {
                title: '离职时间',
                dataIndex: 'leftTime',
                key: 'leftTime',
                width: 100,
                render: this.getMemberRender(0, 'date'),
            }, {
                title: '本月项目确认FTE',
                dataIndex: 'fte',
                key: 'fte',
                width: 120,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: '患者访视相关的FTE',
                dataIndex: 'visitFte',
                key: 'visitFte',
                width: 80,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: 'CRC项目确认FTE',
                dataIndex: 'crcFte',
                key: 'crcFte',
                width: 80,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: '负责医院数量',
                dataIndex: 'hospitalNum',
                key: 'hospitalNum',
                width: 100,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: '管理的城市数量',
                dataIndex: 'cityNum',
                key: 'cityNum',
                width: 120,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: '完成访视数',
                dataIndex: 'visitNum',
                dataIndex: 'visitNum',
                width: 100,
                render: this.getMemberRender(1, 'fill'),
            }, {
                title: '已确认标准访视数',
                dataIndex: 'visitStandardAmount',
                dataIndex: 'visitStandardAmount',
                width: 100,
                render: this.getMemberRender(1, 'fill'),
            }
        ]);

        const getDataSource = () => {
            const dataSource = memberData.map(item => {
                return {
                    ...item,
                }
            });
            return dataSource;
        }

        return (
            <TableC
                loading={memberLoading}
                scrollY={300}
                columns={getColumns()}
                data={getDataSource()}
                className="performanceSupervisorTeam"
                rowKey="performanceSupervisorTeamId"
            />
        )
    }

    getCrfTalbe = () => {
        const { loading, restDatas: { userVisitConfigTypes = [], visitStandardCount = {} } } = this.props;
        const getColumns = () => ([
            {
                title: '',
                dataIndex: 'configName',
                key: 'configName',
                width: 100,
                fixed: 'left',
                className: 'theme-color',
                render: (text, record) => {
                    const obj = {
                        props: {},
                        children: text,
                    };
                    const { rowSpan, colSpan, configName } = record;
                    if (rowSpan) {
                        obj.props.rowSpan = rowSpan;
                    } else {
                        obj.props.rowSpan = 0;
                    }
                    if (colSpan) {
                        obj.props.colSpan = colSpan;
                    }
                    if (configName == '实际访视数') {
                        obj.props.colSpan = 2;
                        obj.props.children = <strong>实际访视数</strong>;
                    } else if (configName == '确认标准访视数') {
                        obj.props.colSpan = 2;
                        obj.props.children = <strong>确认标准访视数</strong>;
                    }
                    return obj;
                }
            }, {
                title: '',
                dataIndex: 'configValue',
                key: 'configValue',
                width: 100,
                fixed: 'left',
                className: 'theme-color',
                render: (text, record) => {
                    const obj = {
                        props: {},
                        children: text,
                    };
                    const { configValue, configName } = record;
                    if (!configValue) {
                        obj.props.colSpan = 0;
                    }
                    if (configName == '实际访视数') {
                        obj.props.colSpan = 0;
                    } else if (configName == '确认标准访视数') {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                }
            }, {
                title: '项目分类',
                children: [
                    {
                        title: '肿瘤注册研究',
                        dataIndex: 'tumourVisitCount',
                        key: 'tumourVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '危急症注册研究',
                        dataIndex: 'criticalVisitCount',
                        key: 'criticalVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '其他药物注册研究',
                        dataIndex: 'otherDrugsVisitCount',
                        key: 'otherDrugsVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: 'I期患者研究',
                        dataIndex: 'onePatientVisitCount',
                        key: 'onePatientVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: 'I期健康人研究',
                        dataIndex: 'oneHealthyVisitCount',
                        key: 'oneHealthyVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: 'BE研究',
                        dataIndex: 'beVisitCount',
                        key: 'beVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '上市后IV期研究',
                        dataIndex: 'listingFourVisitCount',
                        key: 'listingFourVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '器械或诊断试剂或疫苗注册研究',
                        dataIndex: 'diagnosisVisitCount',
                        key: 'diagnosisVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '医疗器械研究',
                        dataIndex: 'observabilityVisitCount',
                        key: 'observabilityVisitCount',
                        width: 120,
                        render: this.getCrfRender,
                    }, {
                        title: '诊断试剂研究',
                        dataIndex: 'diagnosticReagentVisitCount',
                        key: 'diagnosticReagentVisitCount',
                        width: 120,
                        render: this.getCrfRender,
                    }, {
                        title: '疫苗研究',
                        dataIndex: 'vaccineResearchVisitCount',
                        key: 'vaccineResearchVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }, {
                        title: '研究者发起研究',
                        dataIndex: 'rsearchersInitiateVisitCount',
                        key: 'rsearchersInitiateVisitCount',
                        width: 120,
                        render: this.getCrfRender,
                    }, {
                        title: 'NA',
                        dataIndex: 'naVisitCount',
                        key: 'naVisitCount',
                        width: 100,
                        render: this.getCrfRender,
                    }
                ]
            }
        ]);
    
        const getDataSource = () => {
            let dataSource = [];
            const len = userVisitConfigTypes.length;
            if (len > 0) {
                dataSource = [...userVisitConfigTypes];
                dataSource[0].configName = '各访视类型数量';
                dataSource[0].rowSpan = len - 1;
                dataSource[len - 1].configName = '实际访视数';
                dataSource[len - 1].rowSpan = 1;
                const standardVisitNum = {};
                for (let [key, value] of Object.entries(visitStandardCount)) {
                    if (key.endsWith('VisitStandard')) {
                        const newKey = key.replace('VisitStandard', 'VisitCount');
                        standardVisitNum[newKey] = value;
                    }
                }
                dataSource.push({
                    ...standardVisitNum,
                    configName: '确认标准访视数',
                    rowSpan: 1,
                });
            }
            return dataSource;
        };

        return (
            <TableC
                scrollY={300}
                loading={loading}
                columns={getColumns()}
                data={getDataSource()}
                className="visit"
            />
        )
    }

    getCrfRender = (text, record) => {
        const { configName } = record;
        if (configName == '访视数量') {
            return <strong>{text}</strong>;
        }
        return text;
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        } else if (type === 'toChinese') {
            // 转中文
            const { contrastList } = options;
            return (text, record) => {
                return (contrastList.find(i => i.value === text) || {}).name;
            }
        } else if (type == 'custom') {
            return (text, record) => {
                const { loseType, investigationName, hospitalName, departmentName } = record;
                if (loseType === 'LOSE_INVESTIGATION') {
                    return investigationName;
                } else if (loseType === 'LOSE_HOSPITAL') {
                    return hospitalName;
                } else if (loseType === 'LOSE_DEPARTMENT') {
                    return `${hospitalName}(${departmentName})`;
                }
                return text;
            }
        } else if (type === 'split') {
            // 文本换行
            const { num } = options;
            return (text, record) => {
                const arr  = text ? text.split(',') : [];
                const len = arr.length;
                return (
                    arr.map((item, index) => {
                        if ((index + 1) % num == 0) {
                            return <span>{item}{(len - 1 === index) ? '' : ','}&nbsp;&nbsp;<br /></span>;
                        } else {
                            return `${item}${(len - 1 === index) ? '' : ','}`;
                        }
                    })
                )
            }
        }
    }

    getRequireTable = () => {
        const { loading, restDatas: { performanceRequirementHistoryList = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '需求编号',
                dataIndex: 'requirementCode',
                key: 'requirementCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
                fixed: 'left',
            }, {
                title: '中心',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 140,
            }, {
                title: '科室',
                dataIndex: 'departmentName',
                key: 'departmentName',
                width: 140,
            }, {
                title: '科室leader',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 80,
                render: (text, record) => {
                    const { employeeCode } = record;
                    return (
                        <span>
                            {text}
                            <br />
                            {(text && employeeCode) ? `(${employeeCode})` : ''}
                        </span>
                    );
                }
            }, {
                title: '新建需求时间',
                dataIndex: 'createTime',
                key: 'createTime',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '预计上岗时间',
                dataIndex: 'planOnDutyTime',
                key: 'planOnDutyTime',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '处理需求时间',
                dataIndex: 'assignmentTime',
                key: 'assignmentTime',
                width: 100,
                render: this.getRender('date'),
            }, {
                title: '人员到位时间',
                dataIndex: 'employeeArrivalTimeStr',
                key: 'employeeArrivalTimeStr',
                width: 100,
                render: this.getRender('split', { num: 1 }),
            }, {
                title: '预计上岗时间-新建需求时间',
                dataIndex: 'planDay',
                key: 'planDay',
                width: 100,
            }, {
                title: '预计上岗时间-人员到位时间',
                dataIndex: 'employeeArrivalDay',
                key: 'employeeArrivalDay',
                width: 100,
                render: this.getRender('split', { num: 6 })
            }, {
                title: 'BUFFER(30-(预计上岗时间-新建需求时间))',
                dataIndex: 'planThirtyDay',
                key: 'planThirtyDay',
                width: 140,
            }, {
                title: '是否满足处理速度',
                dataIndex: 'satisfiedDealSpeed',
                dataIndex: 'satisfiedDealSpeed',
                width: 80,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: null,
                        name: '未处理',
                    }, {
                        value: 0,
                        name: '不满足',
                    }, {
                        value: 1,
                        name: '满足',
                    }],
                }),
            },];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = performanceRequirementHistoryList.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <TableC
                loading={loading}
                scrollY={300}
                columns={getColumns()}
                data={getDataSource()}
                className="requireHandle"
            />
        )
    }

    render() {
        const { panes, activeKey } = this.state;
        return (
            <div className="tab-performance">
                <div style={{ lineHeight: '48px' }}>1.主要业绩分明细</div>
                { this.getMainTable() }
                <div style={{ lineHeight: '48px' }}>2.团队人员明细</div>
                {
                    panes.length > 1 ?
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {
                                panes.map(pane => <TabPane tab={pane.title} key={pane.title}>{pane.content}</TabPane>)
                            }
                        </Tabs>
                    :
                        this.getMemberTable()
                }
                <div style={{ lineHeight: '48px' }}>3.团队人员完成的访视数明细</div>
                { this.getCrfTalbe() }
                <div style={{ lineHeight: '48px' }}>4.需求处理情况明细</div>
                { this.getRequireTable() }
            </div>
        )
    }
}

export default MainContent;


// WEBPACK FOOTER //
// ./src/components/home/leaderPerformanceDetail/MainContent.js